import * as React from 'react';

function ProgramsTab(props) {
    const school = props.school;

    const categories = [
        { name: 'College and Career', programs: school?.programsCollegeAndCareer.split(', ').filter(p => p != '') },
        { name: 'College Prep', programs: school?.programsCollegePrep.split(', ').filter(p => p != '') },
        { name: 'Creative', programs: school?.programsCreative.split(', ').filter(p => p != '') },
        { name: 'Credit Recovery', programs: school?.programsCreditRecovery.split(', ').filter(p => p != '') },
        { name: 'Health and Wellness', programs: school?.programsHealthAndWellness.split(', ').filter(p => p != '') },
        { name: 'Life and Leadership', programs: school?.programsLifeAndLeadership.split(', ').filter(p => p != '') },
        { name: 'Parent and Community', programs: school?.programsParentAndCommunity.split(', ').filter(p => p != '') },
        { name: 'Scholastic', programs: school?.programsScholastic.split(', ').filter(p => p != '') },
        { name: 'Schoolwide', programs: school?.programsSchoolWide.split(', ').filter(p => p != '') },
        { name: 'Special Programs', programs: school?.programsSpecialPrograms.split(', ').filter(p => p != '') },
        { name: 'Sports and Fitness', programs: school?.programsSportsAndFitness.split(', ').filter(p => p != '') },
        { name: 'Summer', programs: school?.programsSummer.split(', ').filter(p => p != '') },
        { name: 'Summer Instructional', programs: school?.programsSummerInstructional.split(', ').filter(p => p != '') },

    ];

    return <div className="profile-section container-fluid">
        {/*{categories.filter(cat => cat.programs.length > 0).length == 0 ? <></>:<p>There are no programs available</p>}*/}
        {categories.filter(cat => cat.programs.length > 0).map(category => <div key={category.name} className="program-list row">
            <div className="col-sm-4 category">
                <h2>{category.name}</h2>
            </div>
            <div className="col-sm-8 programs">
                <ul>
                    {category.programs.map(program => <li key={program}>{program}</li>)}
                </ul>
            </div>
        </div>
        )}
    </div>
}

export default ProgramsTab;